import * as React from "react";
import FooterContent from "./FooterContent";

function Footer() {
  return (
    <footer
      style={{ flexShrink: 0, paddingLeft: 5, paddingRight: 5, marginTop: 16 }}
    >
      <FooterContent />
    </footer>
  );
}

export default Footer;
